import { Controller } from "stimulus";

import { submitForm } from "init/ajax";
import { closeModal, loadModalUrl } from "../modal/utils";
import { updateCheckoutForm, submitAddOn, removeAddOn } from "init/checkout";

export default class extends Controller {
  async openAccountModal(event) {
    event.preventDefault();

    await loadModalUrl(event.target.href);

    closeModal(this.element);
  }

  reloadPage() {
    Site.getRequest(window.location.href, e => {
      let html = document.createElement("html");
      html.innerHTML = e.target.responseText;
      closeModal(this.element);
      document.body.innerHTML = html.querySelector("body").innerHTML;
    });
  }

  async submitBooking(event) {
    event.preventDefault();

    const form = event.target;
    // Consider everything valid if browser validations aren't supported
    if (!form.reportValidity || form.reportValidity()) {
      const responseHTML = await submitForm(form);

      document.body.appendChild(responseHTML);

      setTimeout(this.reloadPage.bind(this), 2000);
    }
  }

  remove(e) {
    this.removeAddon(e);
    closeModal(this.element);
  }

  removeAddon = removeAddOn;
  updateAddOns = updateCheckoutForm;
  submitAddOn = submitAddOn;

  updateAddOn(e) {
    e.preventDefault();

    let el = e.target.closest(".cta-wrap");
    let id = el.querySelector("[name='addon_id']").value;
    let qty = el.querySelector("[name='quantity']").value;
    this.submitAddOn({ id: id, quantity: qty });
    closeModal(this.element);
  }
}
